import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const FinalInspectionCompletedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.FINAL_INSPECTION_COMPLETED),
  finalInspectionCompletedAt: z.coerce.date().nullable(),
  finalInspectionFailureReason: z.string().nullable(),
  correctionsNeeded: z.boolean(),
});
